import { useEffect, useRef } from 'react';

function CursorTrail() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let particles = [];
    let mouse = { x: -200, y: -200 };
    let raf;

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    const handleMove = (e) => {
      mouse = { x: e.clientX, y: e.clientY };

      for (let i = 0; i < 3; i++) {
        particles.push({
          x: mouse.x,
          y: mouse.y,
          vx: (Math.random() - 0.5) * 2,
          vy: (Math.random() - 0.5) * 2 - 1,
          life: 1,
          decay: 0.012 + Math.random() * 0.015,
          size: Math.random() * 4 + 2,
          type: 'spark',
        });
      }

      particles.push({
        x: mouse.x,
        y: mouse.y,
        vx: (Math.random() - 0.5) * 0.5,
        vy: -Math.random() * 1.5 - 0.5,
        life: 1,
        decay: 0.008 + Math.random() * 0.006,
        size: Math.random() * 8 + 6,
        type: 'ember',
      });
    };

    document.addEventListener('mousemove', handleMove);

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i];
        p.x += p.vx;
        p.y += p.vy;
        p.life -= p.decay;
        p.vy -= 0.02;

        if (p.life <= 0) {
          particles.splice(i, 1);
          continue;
        }

        ctx.save();

        if (p.type === 'ember') {
          const grad = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.size * p.life);
          grad.addColorStop(0, `rgba(246, 99, 0, ${p.life * 0.6})`);
          grad.addColorStop(0.5, `rgba(246, 99, 0, ${p.life * 0.3})`);
          grad.addColorStop(1, 'rgba(246, 99, 0, 0)');
          ctx.fillStyle = grad;
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.size * p.life, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.globalAlpha = p.life;
          ctx.fillStyle = `rgba(246, 99, 0, ${p.life})`;
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.size * p.life, 0, Math.PI * 2);
          ctx.fill();
        }

        ctx.restore();
      }

      if (particles.length > 300) particles = particles.slice(-300);

      raf = requestAnimationFrame(draw);
    };

    raf = requestAnimationFrame(draw);

    return () => {
      window.removeEventListener('resize', resize);
      document.removeEventListener('mousemove', handleMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        /* Below nav/modals; above page so embers show — must stay below MobileVerticalScrollRail (999). */
        zIndex: 8,
      }}
    />
  );
}

export default CursorTrail;
